
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from 'react';
export default function EarnSection() {
    const [activeTab, setActiveTab] = useState('earn');
    const tabs = [
        { id: 'earn', label: 'Earn', icon: '/images/earn/cash-user-man-message.svg' },
        { id: 'trade', label: 'Trade', icon: '/images/earn/patient-register.svg' },
        { id: 'invest', label: 'Invest', icon: '/images/earn/cash-molecule.svg' },
        { id: 'invite', label: 'Invite', icon: '/images/earn/email-address-add.svg' }
    ];
    return (<section className={'earn_section'}>


            <div className="container">
                <div className="earn_section_wrapper">
                    <ul className={'earn_nav'}>
                        {tabs.map((el, i) => {
            return <li key={el.id} className={'earn_nav_item'}>
                                <span>{el.label}</span>
                                <img src={el.icon} alt={el.label} width={24} height={24} className='earn_nav_item_icon'/>
                                <img src={`/images/vector_${i <= 1 ? '1' : '2'}.svg`} alt={el.label} width={976} height={179} className='earn_nav_item_after'/>
                            </li>;
        })}
                    </ul>
                    <div className={'earn_main'}>
                        <h3>Earn 15% interest on your total trading equity.</h3>
                        <p>Interest applies across all trading accounts and supported native currencies.</p>
                        <img src={'/images/earn_bg_small.webp?v=2'} alt="" role="presentation" width={446} height={374} className='earn_bg_nav'/>
                        <p className={'last'}>Interest applies across all trading accounts and supported native currencies.</p>
                        <img src={`/images/right_earn.svg`} alt={'earn HDFX'} width={996} height={630} className='earn_section_media right'/>
                    </div>
                </div>
            </div>
        </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3b7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//EarnSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3b7__ as getStaticProps }
  